import React from "react";
import { PrintLabelSpec } from "../utils/printGrouping";
import { PrintSettingsStateTypes } from "../types/print_settings";

interface PrintRowsProps {
  groups: PrintLabelSpec[][];
  settings: PrintSettingsStateTypes;
  printStyles: React.CSSProperties;
  pageStyle?: string;
  renderLabel: (label: PrintLabelSpec, index: number) => React.ReactNode;
}

const PrintRows: React.FC<PrintRowsProps> = ({
  groups,
  settings,
  printStyles,
  pageStyle,
  renderLabel,
}) => (
  <>
    {groups.map((group, rowIndex) => (
      <div
        key={rowIndex}
        className={`border border-gray-500 border-dashed flex justify-start print-container ${
          rowIndex !== 0 ? "not-first-elm" : ""
        } ${settings.printPerLine > 1 ? "flex-row items-center" : "flex-col items-center"}`}
        style={{ ...printStyles, breakAfter: "page" }}
      >
        {pageStyle ? <style>{pageStyle}</style> : null}
        {group.map((label, labelIndex) => (
          <div
            className="text-center left relative z-[999]"
            style={{ width: `${100 / (settings.printPerLine || 1)}%` }}
            key={`${label.product.itemNumber}-${label.kind}-${rowIndex}-${labelIndex}`}
          >
            {renderLabel(label, labelIndex)}
          </div>
        ))}
      </div>
    ))}
  </>
);

export default PrintRows;
